var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassword = function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.343 10.343C4 12.686 4 16.458 4 24c0 7.543 0 11.314 2.343 13.657S12.458 40 20 40h8c7.542 0 11.314 0 13.657-2.343S44 31.543 44 24c0-7.542 0-11.314-2.343-13.657S35.543 8 28 8h-8C12.458 8 8.686 8 6.343 10.343M16 26a2 2 0 1 0 0-4 2 2 0 0 0 0 4m10-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
export default SvgPassword;